"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const samedaydeliverybrand02 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 72 53",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-samedaydeliverybrand02` : '') + (description ? ` desc-samedaydeliverybrand02` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-samedaydeliverybrand02"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-samedaydeliverybrand02"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M50.553 51.728c-.82.43-1.78.46-2.62.08l-21.7-9.77c-1.15-.52-1.89-1.71-1.89-3.02v-22.3c0-1.28.7-2.44 1.8-2.98l20.34-10.01a2.96 2.96 0 0 1 2.47-.07l20.15 8.5c1.18.5 1.96 1.71 1.96 3.05v23.67c0 1.24-.67 2.38-1.72 2.94l-18.79 9.91Z",
    fill: "#FFCCD8",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M46.063 50.648c-.56 0-1.11-.12-1.64-.36l-21.7-9.77c-1.51-.68-2.48-2.22-2.48-3.93v-22.3c0-1.65.92-3.17 2.36-3.87L42.943.408c1.04-.51 2.24-.54 3.3-.1l20.15 8.5c1.56.66 2.57 2.22 2.57 3.97v23.67c0 1.62-.86 3.09-2.26 3.82l-18.79 9.92c-.58.31-1.22.46-1.86.46h.01Zm-1.36-48.66c-.3 0-.6.07-.88.2l-20.34 10.01c-.75.37-1.24 1.19-1.24 2.08v22.3c0 .93.51 1.75 1.3 2.11l21.7 9.77c.56.25 1.19.23 1.74-.05l18.79-9.92c.72-.38 1.19-1.19 1.19-2.05v-23.67c0-.95-.53-1.78-1.35-2.13l-20.15-8.5c-.25-.1-.51-.16-.77-.16l.01.01Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M46.163 23.048a.996.996 0 0 1-.47-1.88l21.22-11.19a.996.996 0 0 1 1.35.42c.26.49.07 1.09-.42 1.35l-21.22 11.19c-.15.08-.31.12-.47.12l.01-.01Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M46.163 50.638c-.55 0-1-.45-1-1v-26.91l-23.73-9.39a.995.995 0 0 1-.56-1.3.99.99 0 0 1 1.3-.56l24.36 9.64a1 1 0 0 1 .63.93v27.59c0 .55-.45 1-1 1ZM56.233 17.738c-.14 0-.28-.03-.41-.09l-23-10.44a1 1 0 0 1 .82-1.82l23 10.44a1 1 0 0 1-.41 1.91ZM13.463 35.258c-.15 0-.3-.03-.44-.1l-12.45-6.06c-.5-.24-.71-.83-.48-1.33.23-.5.83-.71 1.33-.48l.15.07 12.32 6c.5.24.7.84.46 1.34-.17.36-.53.56-.9.56h.01ZM13.463 23.768c-.15 0-.3-.03-.44-.1l-7.38-3.59a1 1 0 0 1-.46-1.34 1 1 0 0 1 1.34-.46l7.38 3.59c.5.24.7.84.46 1.34-.17.36-.53.56-.9.56ZM13.463 12.268c-.15 0-.3-.03-.44-.1l-3.51-1.71a1 1 0 0 1-.46-1.34 1 1 0 0 1 1.34-.46l3.51 1.71c.5.24.7.84.46 1.34-.17.36-.53.56-.9.56Z",
    fill: "#E90B5A"
  }));
};
var _default = exports.default = samedaydeliverybrand02;